export function calculateBase64Length(byteCount: number) {
    return 4 * Math.ceil(byteCount / 3);
}
